module.exports = __webpack_public_path__ + "static/media/weight-equal.14c28b3e.png";